import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=356c4a2a&scoped=true&"
import script from "./LicenseList.vue?vue&type=script&lang=js&"
export * from "./LicenseList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/license.css?vue&type=style&index=0&lang=css&"
import style1 from "./LicenseList.vue?vue&type=style&index=1&id=356c4a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c4a2a",
  null
  
)

export default component.exports